/**
 * Created with IntelliJ IDEA.
 * User: abahlk
 * Date: 12.07.13
 * Time: 10:59
 * To change this template use File | Settings | File Templates.
 */

import { ExternalLoggingConstants } from "../ExternalLoggingConstants";
import { AbstractLogObject } from "../logObjects/AbstractLogObject";
import { BasicLogObjectFactory } from "./BasicLogObjectFactory";

export class FileErrorLOFactory extends BasicLogObjectFactory {
    public static ASSET_NOT_VERSIONED_FILE_ERROR: number = 14001;

    private static PARAM_ASSETNAME: string = "assetName";

    private static FILE_ERROR: number = 14;

    private _assetName: string;

    constructor(subErrorId: number, assetName: string = null) {
        super();

        this._subErrorId = subErrorId;
        this._assetName = assetName;
    }

    public create(): AbstractLogObject {
        // Build the commonData
        let lo: AbstractLogObject = super.create();

        // Set custom data
        lo.logData.set(ExternalLoggingConstants.PARAM_LOG_EVENT_ID, FileErrorLOFactory.FILE_ERROR.toString());

        if (this._assetName !== undefined) {
            lo.logData.set(FileErrorLOFactory.PARAM_ASSETNAME, this._assetName);
        }

        return lo;
    }
}
